import { render, staticRenderFns } from "./Short_form.vue?vue&type=template&id=450ed80a&scoped=true&"
import script from "./Short_form.vue?vue&type=script&lang=js&"
export * from "./Short_form.vue?vue&type=script&lang=js&"
import style0 from "./Short_form.vue?vue&type=style&index=0&id=450ed80a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ed80a",
  null
  
)

export default component.exports